import React  from 'react'

export default function TextMessagesTemplate ({row}) {
  const forMattedText = row.text?.match(/<[^>]+>/) ? row.text : row.text.replace(/\n/g, '<br/>')
  return (
    <div className='text-left'>
      <div dangerouslySetInnerHTML={{ __html: forMattedText }}/>
    </div>
  )
}